import type { CollabUser } from "@ease/page-builder/collaboration";

export function CollabAvatars({
  collaborators,
}: {
  collaborators: CollabUser[];
}) {
  if (collaborators.length === 0) {
    return null;
  }

  return (
    <div className="flex -space-x-2">
      {collaborators.slice(0, 5).map((collaborator) => (
        <div
          key={collaborator.userId}
          className="flex h-7 w-7 items-center justify-center rounded-full border-2 border-[var(--color-background)] text-[10px] font-bold text-white"
          style={{ backgroundColor: collaborator.color }}
          title={buildCollaboratorTitle(collaborator.displayName, collaborator.cursor?.componentId)}
        >
          {collaborator.displayName.charAt(0).toUpperCase()}
        </div>
      ))}
      {collaborators.length > 5 ? (
        <div className="flex h-7 w-7 items-center justify-center rounded-full border-2 border-[var(--color-background)] bg-[var(--color-surface)] text-[10px] font-medium text-[var(--color-muted-foreground)]">
          +{collaborators.length - 5}
        </div>
      ) : null}
    </div>
  );
}

export function buildCollaboratorTitle(name: string, componentId?: string): string {
  if (!componentId) {
    return name;
  }
  return `${name} editing ${componentId}`;
}
